import { IReverseParserParams } from '../../../../guidelinePublicCompanies/PerformanceMetrics/config/reverseParser/types';

const reverseParser = (params: IReverseParserParams) => {
  Object.values(params.cells).forEach(cell => {});
};

export default reverseParser;
